const sizeClasses = {
  small: "h-8 min-w-24 px-4 py-2 text-sm",
  medium: "h-10 min-w-28 px-5 py-2.5 text-base",
  large: "h-12 min-w-32 px-6 py-3 text-base",
};

const variantClasses = {
  primary:
    "border-primary bg-primary text-[#292929] hover:bg-yellow-300 active:border-[#a67502] active:bg-[#a67502] active:text-white focus-visible:ring-primary/40",
  secondary:
    "border-primary bg-[#feffe7] text-[#a67502] hover:bg-yellow-100 active:border-[#a67502] active:bg-yellow-50 focus-visible:ring-primary/35",
  ghost:
    "border-transparent bg-white text-[#292929] hover:border-slate-200 hover:bg-[#efefef] active:border-[#dcdcdc] active:bg-[#efefef] focus-visible:ring-slate-300",
  danger:
    "border-[#ad2828] bg-[#fdf3f3] text-[#ad2828] hover:bg-red-50 active:bg-red-100 focus-visible:ring-red-200",
};

const disabledClasses =
  "disabled:border-[#bdbdbd] disabled:bg-[#bdbdbd] disabled:text-[#7c7c7c] disabled:opacity-75";

function ArrowActionIcon() {
  return (
    <svg
      aria-hidden="true"
      className="size-4 shrink-0"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M9 10 4 15l5 5" />
      <path d="M20 4v7a4 4 0 0 1-4 4H4" />
    </svg>
  );
}

function LoadingDots() {
  return (
    <span aria-hidden="true" className="flex w-[18px] items-center justify-between">
      <span className="size-1 rounded-full bg-current" />
      <span className="size-1 rounded-full bg-current" />
      <span className="size-1 rounded-full bg-current" />
    </span>
  );
}

export default function EsyaButton({
  as: Component = "button",
  children,
  className = "",
  disabled = false,
  iconLeft = false,
  iconRight = false,
  loading = false,
  size = "large",
  type = "button",
  variant = "primary",
  ...props
}) {
  const isButton = Component === "button";
  const isDisabled = disabled || loading;
  const componentProps = isButton
    ? { disabled: isDisabled, type }
    : { "aria-disabled": isDisabled || undefined };

  return (
    <Component
      className={`inline-flex items-center justify-center gap-2 rounded-lg border font-semibold leading-6 outline-none transition duration-150 focus-visible:ring-2 focus-visible:ring-offset-2 ${sizeClasses[size]} ${variantClasses[variant]} ${disabledClasses} ${className}`}
      {...componentProps}
      {...props}
    >
      {loading ? <LoadingDots /> : iconLeft ? <ArrowActionIcon /> : null}
      <span>{children}</span>
      {!loading && iconRight ? <ArrowActionIcon /> : null}
    </Component>
  );
}
